<template>
  <div class="">
    <div class="position-fixed t-0 w-fill z-index-99">
      <div class="justify-content-space-between align-items-center"
           style="background-image: linear-gradient(to bottom,#51C027 0%,#9DC091 200%);">
        <div class="w-70 dropdown">
          <div class="pd-l-10">
            <van-dropdown-menu>
              <van-dropdown-item @change="onSortTypeChange" v-model="sortType" :options="sortList"/>
            </van-dropdown-menu>

          </div>
        </div>
        <div class="flex-1">
          <form action="">
            <van-search v-model="keyword" placeholder="搜索资源" shape="round"
                        @search="onSearch"/>
          </form>
        </div>
        <div class="w-60">
          <div @click="onPurchasedClick" class="c-f mg-l-4 fs-16 align-items-center">
            <van-icon class="" name="bag"/>
            已购
          </div>
        </div>
        <div v-if="$parent.appInner && $parent.isIos" class="w-60">
          <div @click="onAppCoinClick" class="c-f mg-l-4 fs-16 align-items-center">
            <van-icon name="gold-coin"/>
            账户
          </div>
        </div>
      </div>
      <div class="bg-f position-relative pd-b-4" :class="{'shadow-2':showShadow}">
        <van-tabs color="#51C027" title-active-color="#51C027"
                  v-model="levelId"
                  @click="onLevelChange">
          <van-tab v-for="item in levelList" :title="item.text" :name="item.value"></van-tab>
        </van-tabs>
      </div>
    </div>

    <div class="left-menu position-fixed bdr-10 l-0 t-100 b-0 w-80 fs-12 text-strong" style="overflow-y: scroll">
      <div @click="onSubjectClick(item)" v-for="item in subjectList"
           class="pd-t-10 pd-b-10"
           :class="subjectId == item.subjectId?'bg-f9f c-app-green':'c-9'">
        <div class="text-ellipsis-1 text-align-center ">{{ item.subjectName }}</div>
      </div>
    </div>

    <!--    <div class="position-relative">
          <div class="position-relative display-flex nowap pd-l-20 bg-f pd-t-110 hide-scrollbar"
               style="overflow-y: hidden ;box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.05);">
            <div :id="item.subjectId" @click="onSubjectClick(item)" v-for="(item,index) in subjectList"
                 class="list display-inline-block text-align-center fs-14"
                 :class="subjectId == item.subjectId?'checked':'c-6'">
              <div class="text-ellipsis-1 text-align-center ">{{ item.subjectName }}</div>
            </div>
          </div>
          <div v-if="subjectList.length > 10"
               class="position-absolute bg-f c-9 w-60 justify-content-center align-items-center r-0 b-0 b-0 h-50"
               style="border-left: 1px solid #f1f1f1" @click="onSubShow">
            <van-icon class="fs-24 c-app-green bg-f" name="apps-o"/>
          </div>
        </div>-->

    <div class="pd-t-105 pd-l-90 pd-r-10 bg-f9f">
      <div v-for="(item,index) in cardList" class="mg-b-10">
        <card-item class="bg-f bdr-10" style="box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.05);" :card="item"></card-item>
      </div>
      <div v-if="isNoMore && cardList>0" class="pd-25 fs-12 c-9 text-align-center">没有更多了</div>
      <van-empty v-if="isNoMore && cardList.length==0" description="没有更多了"/>
    </div>
    <van-popup
        v-model:show="subShow" round position="right" style="margin-top: 110px; height: 100vh">
      <div id="subShow" class="display-flex flex-wrap bg-f9f pd-15 h-fill"
           style="overflow-y: auto;">
        <div @click="onSubjectClick(item)" v-for="item in subjectList"
             class="list display-inline-block text-align-center fs-14"
             :class="subjectId == item.subjectId?'checked':'c-6'">
          <div class="text-align-center ">{{ item.subjectName }}</div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import cardItem from '../components/cardItem'
import userLabel from '../components/userLabel';
import request from '../libs/api.request'
import storage from "../libs/storage";
import conf from "../libs/conf";

export default {
  name: "index",
  components: {
    cardItem,
    userLabel,
  },
  data() {
    return {
      showShadow: false,
      subShow: false,
      keyword: '',
      conf: conf,
      showPanel: false,
      showPublishNotice: false,
      levelId: 0,
      subjectId: 0,
      sortType: 0,
      sortList: [
        {text: '热门', value: 0},
        {text: '新上', value: 3},
      ],
      cardList: [],
      currentPage: 1,
      orderMessageCount: 1,
      pageSize: 20,
      isNoMore: false,//是否没有更多了
      isLoadData: false,//是否正在加载数据
      subjectList: [],
      levelList: [
        {value: 0, text: '全阶段'},
        {value: 6, text: '👨‍🎓考研'},
        {value: 7, text: '📇考证/考公/职考'},
        {value: 5, text: '🏫大学'},
        {value: 4, text: '📚高中'},
        {value: 3, text: '📗初中'},
        {value: 2, text: '📃小学'},
        {value: 1, text: '🔖学前'},
        {value: 100, text: '📋️模板'},
        {value: 99, text: '🏳️其他'},
      ]
    }
  },
  methods: {
    onAppCoinClick() {
      gotoAppCoin.postMessage("");
    },
    onSubShow() {
      if (this.subShow) {
        this.subShow = false;
      } else {
        this.subShow = true;
      }
    },
    onMenuClick() {
      this.showPanel = true;
    },
    getAppVersion() {
      if (akBridge) {
        akBridge.callHandler("getAppVersion", null, (version) => {
          if (version) {
            this.$dialog.alert({
              message: '获取到版本号：' + version,
            });
          }
        });
      } else {
        let version = AnkiDroidJS.getAppVersion();
        if (version) {
          this.$dialog.alert({
            message: '获取到版本号：' + version,
          });
        } else {
          this.$dialog.alert({
            message: '没有获取到版本号',
          });
        }
      }
    },
    onNoticeClick() {
      this.$router.push({path: '/course'})
    },
    getData() {
      this.isLoadData = true;
      request.request({
        url: 'card/recommend',
        params: {
          page: this.currentPage,
          size: this.pageSize,
          subjectId: this.subjectId,
          levelId: this.levelId,
          sortType: this.sortType,
          keyword: this.keyword,
          appVersion: this.$parent.appVersion
        }
      }).then((data) => {
        this.$toast.clear();
        this.isLoadData = false;
        // 搜索出兑换卡片：有 cardId 时走兑换/跳转逻辑
        if (data.cardId) {
          if (data.exchangeUserId) {
            this.$router.push({ path: '/card/' + data.cardId });
            return;
          }
          this.$dialog.confirm({
            title: '兑换资源',
            message: data.title || '',
            confirmButtonText: '确认兑换',
            cancelButtonText: '取消',
          }).then(() => {
            request.request({
              url: 'card/useExchangeCode',
              method: 'post',
              data: { code: this.keyword, cardId: data.cardId },
            }).then(() => {
              this.$toast.success('兑换成功');
              this.$router.push({ path: '/card/' + data.cardId });
            }).catch((err) => {
              this.$toast.fail(err && err.message ? err.message : '兑换失败');
            });
          }).catch(() => {});
          return;
        }
        this.subjectList = data.subjectList;
        this.isNoMore = data.list.length < this.pageSize;
        if (this.currentPage == 1) {
          this.cardList = data.list;
        } else {
          this.cardList = this.cardList.concat(data.list);
        }
      }).catch(() => {
        this.$toast.clear();
        this.isLoadData = false;
      })
    },
    loadMore() {
      if (this.isNoMore || this.isLoadData) {
        console.log(this.isNoMore);
        console.log(this.isLoadData);
        return;
      }

      this.currentPage++;
      this.getData();
    },
    onLevelChange() {
      this.$toast.loading({loadingType: 'spinner', duration: 10000});
      this.currentPage = 1;
      this.subjectId = 0;
      document.body.scrollTop = document.documentElement.scrollTop = 0;
      this.getData();
    },
    onSubjectClick(item) {
      this.subShow = false;
      this.subjectId = item.subjectId;
      this.currentPage = 1;
      document.body.scrollTop = document.documentElement.scrollTop = 0;
      this.getData();
      // 获取目标div
      let elem = document.getElementById(item.subjectId);
      // 确保目标div存在
      if (elem) {
        // 滚动到目标div的位置
        // scrollIntoView() 方法有选项可以平滑滚动
        elem.scrollIntoView({block: "center", inline: "center"});
      }
    },
    onSortTypeChange() {
      this.currentPage = 1;
      this.getData();
    },
    onSearch() {
      this.currentPage = 1;
      this.levelId = 0;
      this.subjectId = 0;
      this.sortType = 0;
      //回到第一页距离
      document.documentElement.scrollTop = 0;
      this.getData();
    },
    onDownloadClick() {
      location.href = 'https://www.ankichinas.cn';
    },
    onPublishNoticeConfirm() {
      this.$parent.execCopy('https://' + location.host + '?app-token=' + this.$cookies.get('authToken'), '链接已复制，请使用浏览器打开');
    },
    onPublishClick() {
      if (this.$parent.loginUser == null) {
        this.$parent.login();
        return;
      }

      // if (true) {
      if (this.$parent.appInner && this.$parent.isAndroid) {
        this.showPublishNotice = true;
      } else {
        location.href = '/card/edit/0'
      }
    },
    onLoginClick() {
      this.$parent.login();
    },
    onMyResourceClick() {
      if (this.$parent.loginUser) {
        location.href = 'https://file.ankichinas.cn/my?op=resource&t=' + (new Date()).getTime();
      } else {
        this.$parent.login();
      }
    },
    onSettingsClick() {
      if (this.$parent.loginUser) {
        location.href = '/my?op=settings';
      } else {
        this.$parent.login();
      }
    },
    onSetUserLabelClick() {
      if (this.$parent.loginUser) {
        this.$refs.myUserLabel.onChangeShow();
      } else {
        this.$parent.login();
      }
    },
    onUserCardBrowsingHistoryClick() {
      if (this.$parent.loginUser) {
        this.$router.push({path: '/userCardBrowsingHistory/'})
      } else {
        this.$parent.login();
      }
    },
    onLogoutClick() {
      this.$dialog.confirm({message: '是否退出登录？'}).then(() => {
        this.$cookies.remove('authToken');
        storage.setUserInfo(null);
        location.reload();
      })
    },
    //滚动条在Y轴上的滚动距离
    getScrollTop() {
      var scrollTop = 0, bodyScrollTop = 0, documentScrollTop = 0;
      if (document.body) {
        bodyScrollTop = document.body.scrollTop;
      }
      if (document.documentElement) {
        documentScrollTop = document.documentElement.scrollTop;
      }
      scrollTop = (bodyScrollTop - documentScrollTop > 0) ? bodyScrollTop : documentScrollTop;
      return scrollTop;
    },
    //文档的总高度
    getScrollHeight() {
      var scrollHeight = 0, bodyScrollHeight = 0, documentScrollHeight = 0;
      if (document.body) {
        bodyScrollHeight = document.body.scrollHeight;
      }
      if (document.documentElement) {
        documentScrollHeight = document.documentElement.scrollHeight;
      }
      scrollHeight = (bodyScrollHeight - documentScrollHeight > 0) ? bodyScrollHeight : documentScrollHeight;
      return scrollHeight;
    },
    //浏览器视口的高度
    getWindowHeight() {
      var windowHeight = 0;
      if (document.compatMode == "CSS1Compat") {
        windowHeight = document.documentElement.clientHeight;
      } else {
        windowHeight = document.body.clientHeight;
      }
      return windowHeight;
    },
    onDownloadAppClick() {
      if (this.$parent.isIos) {
        location.href = "https://apps.apple.com/cn/app/id1540528340";
      } else {
        location.href = "https://ankimemory.com";
      }
    },
    onPurchasedClick() {
      this.$router.push({path: '/purchased'})
    },
    divSubElementOutOfViewport() {
      this.showShadow = window.scrollY > 60;
    },
  },
  created() {
    this.getData();
    window.onscroll = () => {
      // this.$toast(parseInt(this.getScrollTop()) + this.getWindowHeight() + ' ' + this.getScrollHeight());
      if (this.getScrollTop() + this.getWindowHeight() >= this.getScrollHeight() - 150) {
        this.loadMore();
      }
    }
    setTimeout(() => {
      if (this.$parent.loginUser) {
        request.request({
          url: 'order/orderMessageCount',
        }).then(data => {
          this.orderMessageCount = 1;//data.orderMessageCount;
        })
      }
    }, 1000)

    let copyrightNotice = localStorage.getItem("copyrightNotice");
    if (copyrightNotice !== 'read') {
      this.$dialog.alert({
        message: '欢迎来到Anymo资源库\n\nAnymo资源库的内容、资料、讨论等信息均由用户上传及维护的资源分享中心，平台不参与抽成和收取任何费用如您将与其他用户发生交易，请谨慎权衡。尽管我们已尽到最大的努力，但客观上无法避免用户的信息完全合规，如您认为用户上传的信息侵犯了您的知识产权或其他合法权益，请您通过用户协议中的材料要求、联系方式通知我们。',
        'confirmButtonText': '我知道了'
      }).then(() => {
        localStorage.setItem("copyrightNotice", "read");
      })
    }
  },
  mounted() {
    window.addEventListener('scroll', this.divSubElementOutOfViewport, true);
  },
  beforeDestroy() {
    window.onscroll = null;
  }
}

</script>

<style>

.left-menu {
  background: white;
}

.left-menu::-webkit-scrollbar {
  display: none
}

.van-search {
  background-color: rgba(255, 255, 255, 0) !important;
}

.van-search__content {
  background-color: #FFFFFF !important;
}

.van-tab--active {
  font-weight: 900;
}

.list {
  border: 1px solid #e2e5ea;
  padding: 5px 15px;
  border-radius: 100px;
  margin-top: 8px;
  margin-right: 8px;
  margin-bottom: 8px;
  cursor: pointer;
}

.checked {
  color: rgb(81, 192, 39);
  background: rgba(81, 192, 39, 0.1);
  border-color: rgb(81, 192, 39);
}

.dropdown .van-dropdown-menu__bar {
  background: none !important;
  color: white;
  box-shadow: none;
}

.dropdown .van-dropdown-menu__title {
  color: #ffffff;
  font-size: 16px;
}

.dropdown .van-dropdown-menu__title::after {
  border-color: transparent transparent #ffffff #ffffff;
  opacity: 1;
  /*border: 4px solid;*/
}

html::-webkit-scrollbar, body::-webkit-scrollbar {
  display: none !important;
}
</style>
